import { render, staticRenderFns } from "./ActivityFlow.vue?vue&type=template&id=f2bc9a08&scoped=true&"
import script from "./ActivityFlow.vue?vue&type=script&lang=js&"
export * from "./ActivityFlow.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFlow.vue?vue&type=style&index=0&id=f2bc9a08&prod&lang=scss&scoped=true&"
import style1 from "./ActivityFlow.vue?vue&type=style&index=1&id=f2bc9a08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bc9a08",
  null
  
)

export default component.exports